import getItemCoverageData from '@/api/itemCoverage'

const state = {
  itemCoverageTotals: {},
  itemCoverageDetails: {},
  downloadLink: {}
}

const getters = {
  currentTotals: state => state.itemCoverageTotals,
  currentDetails: state => state.itemCoverageDetails
}

const actions = {
  async fetchCurrentItemCoverageData ({ commit, getters, rootGetters, state }, chartName) {
    const targetDate = rootGetters['charts/coverageSelectedDate']
    const currentStore = rootGetters['user/getCurrentStore']
    commit('setLoadingStatus', { isLoading: true, chartName })
    try {
      let itemCoverageData = await getItemCoverageData(chartName, targetDate, currentStore.store_id)
      commit('setItemCoverageData', { itemCoverageData, chartName })
    } catch (e) {
      commit('setItemCoverageError', { chartName })
    } finally {
      commit('setLoadingStatus', { isLoading: false, chartName })
    }
  },
  setCurrentItemCoverageData ({ dispatch }) {
    dispatch('fetchCurrentItemCoverageData', 'tm_monthly_status')
    dispatch('fetchCurrentItemCoverageData', 'tm_latest_items')
    dispatch('fetchCurrentItemCoverageData', 'download_items')
  }
}

const mutations = {
  setLoadingStatus (state, payload) {
    const { isLoading, chartName } = payload
    let stateKey
    switch (chartName) {
      case 'tm_latest_items':
        stateKey = 'itemCoverageDetails'
        break
      case 'tm_monthly_status':
        stateKey = 'itemCoverageTotals'
        break
      case 'download_items':
        stateKey = 'downloadLink'
        break
      default:
        break
    }
    state[stateKey] = {
      ...state[stateKey],
      isLoading
    }
  },
  setItemCoverageData (state, payload) {
    const { itemCoverageData, chartName } = payload
    let stateKey
    switch (chartName) {
      case 'tm_latest_items':
        stateKey = 'itemCoverageDetails'
        break
      case 'tm_monthly_status':
        stateKey = 'itemCoverageTotals'
        break
      case 'download_items':
        stateKey = 'downloadLink'
        break
      default:
        break
    }
    state[stateKey] = itemCoverageData
  },
  setItemCoverageError (state, payload) {
    const { chartName } = payload
    let stateKey
    switch (chartName) {
      case 'tm_latest_items':
        stateKey = 'itemCoverageDetails'
        break
      case 'tm_monthly_status':
        stateKey = 'itemCoverageTotals'
        break
      case 'download_items':
        stateKey = 'downloadLink'
        break
      default:
        break
    }
    state[stateKey] = {
      ...state[stateKey],
      isError: true
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
